<template>
    <el-dialog
        :title="$t('train.extendEndTime')"
        :visible="value"
        width="510px"
        :modal-append-to-body="false"
        :close-on-click-modal="true"
        @close="close"
    >
        <el-form :model="dialogForm" ref="dialogForm"
                 style="margin-right: 40px;"
                 label-width="140px">
            <el-form-item :label="$t('train.name')+'：'">
                <el-input v-model="dialogForm.name" auto-complete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('c.endTime')+'：'" prop="deadline">
                <el-date-picker type="datetime"
                                :placeholder="$t('train.endDate')"
                                v-model="dialogForm.endTime"
                                format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 100%;"
                                clearable
                                :editable="false"
                ></el-date-picker>
            </el-form-item>
        </el-form>
        <div class="extend-tip">
            <p>{{ $t('train.extendRule') }}: </p>
            <p>1. {{ $t('train.extendTip1') }}</p>
            <p>2. {{ $t('train.extendTip2') }}</p>
        </div>
        <div slot="footer" style="text-align: center;margin-top: -10px;">
            <el-button type="primary" @click="endTimeSave('dialogForm')">{{ $t('c.save') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        data: {
            required: true
        },
    },

    data() {
        return {
            dialogForm: {
                id: 0,
                name: '',
                endTime: ''
            }
        }
    },

    computed: {
        pickerOptions() {
            return {
                disabledDate(time) {
                    if (new Date(time).toDateString() === new Date().toDateString()) return false;
                    return time.getTime() < new Date().getTime()
                },
            }
        },
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog();
            }
        },
    },

    methods: {
        initDialog() {
            this.dialogForm.endTime = '';
            this.dialogForm.name = this.data.name;
            this.dialogForm.endTime = this.data.endTime;
            this.dialogForm.id = this.data.id;
        },

        //保存 结束时间延长
        endTimeSave() {
            if (this.dialogForm.endTime && this.dialogForm.endTime.length < 12) {
                this.dialogForm.endTime = this.dialogForm.endTime + ' 23:59:00'
            }
            let timeData = {
                id: this.dialogForm.id,
                endTime: this.dialogForm.endTime
            }
            api.extendEndTime(timeData.id, timeData).then((res) => {
                this.$message({
                    type: 'success',
                    message: this.$t('m.editSuccess')
                });
                this.$emit('success')
                this.close()
            }).catch(error => this.roleLoading = false)
        },

        close() {
            this.$emit('input', false)
        }
    },
}
</script>

<style scoped lang="scss">
.extend-tip {
    margin-left: 58px;
    color: #9f9f9f;
    margin-bottom: 20px;

    > p {
        line-height: 26px;
    }
}
</style>
